import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "aemo_gas",
  "use": "aemo_gas-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"aemo_gas\"><title>aemo_gas</title><path d=\"M6.105.166C10.243 6.695.79 7.155 3.109 13.34c.907 2.411 3.799 2.501 3.799 2.501v-.002c-3.089-3.087.06-6.268.06-6.268s3.439 3.255.424 6.268v.002s2.684 0 4.331-2.006c2.686-3.269 1.58-7.733-1.405-10.936C8.23.658 6.629.235 6.106.165z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/aemo_gas.svg
// module id = 510
// module chunks = 0